import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";

export const LoadingWrapper = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        px: { md: 4, xs: 0 },
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "50vh",
    }),
);
